module.exports = "\n<!--<app-header [data] = \"data\"></app-header>\n\n<app-content [data] =\"data\" ></app-content>\n\n<app-footer></app-footer>-->\n\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main